// The office's grid collision geometry. Pure data and functions, shared by browser and server.
// Positions are the sprite's top-left in tiles; map rows are '0'/'1' strings starting at (x0, y0).
export const SEA_MARGIN = 14;
export const BODY = { l: 0.2, r: 0.8, t: 0.6, b: 0.95 };
export const feet = (x, y) => [Math.floor(x + 0.5), Math.floor(y + 0.8)];

/** Read the current grid from MAP on each call, including after an editor replaces its rows and bounds. */
export function gridCollider(MAP) {
  const inMap = (x, y) => y >= (MAP.y0 ?? 0) && x >= (MAP.x0 ?? 0) && y < (MAP.y0 ?? 0) + MAP.height && x < (MAP.x0 ?? 0) + MAP.width;
  const water = (x, y) => { const x0 = MAP.x0 ?? 0, y0 = MAP.y0 ?? 0;
    return inMap(x, y) ? MAP.water[y - y0][x - x0] === '1' : x >= x0 - SEA_MARGIN && y >= y0 - SEA_MARGIN && x < x0 + MAP.width + SEA_MARGIN && y < y0 + MAP.height + SEA_MARGIN; };
  const footOk = (x, y) => inMap(x, y) && MAP.solid[y - (MAP.y0 ?? 0)][x - (MAP.x0 ?? 0)] !== '1';
  const solid = (x, y, boat) => (boat ? !water(x, y) : !footOk(x, y));
  function boxFree(x, y, boat) {
    const x0 = Math.floor(x + BODY.l), x1 = Math.floor(x + BODY.r - 1e-6), y0 = Math.floor(y + BODY.t), y1 = Math.floor(y + BODY.b - 1e-6);
    for (let ty = y0; ty <= y1; ty++) for (let tx = x0; tx <= x1; tx++) if (solid(tx, ty, boat)) return false;
    return true;
  }
  return { inMap, water, footOk, solid, boxFree };
}
